import { createStyles, CSSProperties, makeStyles } from '@mui/styles';
import { ITheme } from 'theme/types';

const wrapText: CSSProperties = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

const useStyles = makeStyles((theme: ITheme) =>
  createStyles({
    // Items
    item: {
      color: theme.palette.black,
      cursor: 'pointer',
      padding: `${theme.spacing(2)}px 0`,
      borderBottom: `2px solid ${theme.palette.black}`,
      marginBottom: theme.spacing(1),
      width: '100%',

      // '&.Mui-selected': {
      //   backgroundColor: theme.palette.primary['100'],
      // },
      // '&:hover': {
      //   backgroundColor: theme.palette.primary['500'],
      // },
    },
    disabled: {
      opacity: 0.5,
      cursor: 'not-allowed',
      pointerEvents: 'none'
    },
    tooltipContainer: {
      width: '100%',
      display: 'block'
    },
    itemText: {
      ...wrapText,
      textTransform: 'capitalize',

      '& .MuiTypography-body1': {
        fontSize: '18px',
        fontWeight: 700,
        color: theme.palette.black,
      },
    },

    itemIcon: {
      // display: 'inline-block',
      color: theme.palette.white,
      marginLeft: theme.spacing(2),
    },
  })
);

export default useStyles;
